import Breadcrumbs from "components/Common/Breadcrumb"
import React, { useCallback, useEffect, useState } from "react"
import { MetaTags } from "react-meta-tags"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Container,
  Input,
  Row,
} from "reactstrap"
import {
  getPagingTransferLocation,
  addNewTransferLocation,
  updateTransferLocation,
  getTransferLocationById,
  deleteTransferLocation,
  clearTransferLocationError,
} from "store/actions"
import ConfirmDeleteModal from "components/Common/ConfirmDeleteModal"
import { toastMessage } from "helpers/utils"

import { debounce } from "lodash"
import ModalForm from "containers/transfer-location/ModalForm"
import TransferLocationTable from "containers/transfer-location/TransferLocationTable"

const TransferLocationList = (props) => {
  const [ id, setId ] = useState(null)
  const [ term, setTerm ] = useState('')
  const [ page, setPage ] = useState(1)
  const [ pageSize, setPageSize ] = useState(10)
  const [ modalEditIsOpen, setModalEditIsOpen ] = useState(false)
  const [ modalAddIsOpen, setModalAddIsOpen ] = useState(false)
  const [ modalConfirmDeleteIsOpen, setModalConfirmDeleteIsOpen ] =
      useState(false)

  const {
    getPagingTransferLocation,
    addNewTransferLocation,
    deleteTransferLocation,
    updateTransferLocation,
    clearTransferLocationError,
    getTransferLocationById,
    transferLocation,
  } = props
  
  const {   
    message,
    items,
    item,
    loading,
    itemCount,
    pageCount
  } = transferLocation;
 
  const debouncedFetchData = useCallback(debounce(term => {
    setTerm(term)
  }, 1000), [])

  useEffect(() => {
    getPagingTransferLocation({ page, pageSize, term })
  }, [ page, pageSize, term ])

  useEffect(() => {
    if (message) {
      toastMessage(message)
      clearTransferLocationError()
    }
  }, [ message ])

  const handleOnEdit = id => {
    getTransferLocationById(id)
    setModalEditIsOpen(true)
  }

  const handleUpdate = supplier => {
    updateTransferLocation(supplier)
    setModalEditIsOpen(false)
  }

  const handleOnAddNew = () => {
    setModalAddIsOpen(true)
  }

  const handleSubmit = item => {
    addNewTransferLocation(item)
    setModalAddIsOpen(false)
  }

  const handleConfirmDelete = id => {
    setId(id)
    setModalConfirmDeleteIsOpen(true)
  }

  const handleDelete = () => {
    deleteTransferLocation(id)
    setModalConfirmDeleteIsOpen(false)
  }


  return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Transfer Location | CR TechSoft</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="Transfer Location" breadcrumbItem="Transfer Location List"/>
            <Row>
              <Col md={ 12 }>
                <Card className="mb-1 rounded-3">
                  <CardHeader className="bg-transparent border pb-0 pt-3">
                    <Row className="g-1">
                      <Col md={ 2 }>
                        <div className="search-box me-2 mb-2 d-inline-block">
                          <div className="position-relative">
                            <Input
                                type="text"
                                placeholder="Quick Search ..."
                                onChange={ (e) => {
                                  debouncedFetchData(e.target.value)
                                } }
                            ></Input>
                            <i className="fas fa-search search-icon"/>
                          </div>
                        </div>
                      </Col>
                      <Col md={ 2 }></Col>
                      <Col md={ 2 }></Col>
                      <Col md={ 2 }></Col>
                      <Col md={ 4 }>
                        <div className="text-sm-end">
                          <Button
                              type="button"
                              color="primary"
                              className="me-1"
                              onClick={ handleOnAddNew }
                          >
                            <i className="fas fa-plus"/> Add New
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </CardHeader>
                  <Collapse isOpen={ false }>
                    <CardBody className="pb-1"></CardBody>
                  </Collapse>
                </Card>
              </Col>
              <Col md={ 12 }>
                { items && (
                    <TransferLocationTable
                        items={ items }
                        itemCount={ itemCount }
                        page={ page }
                        totalPage={ pageCount }
                        loading={ loading }
                        defaultPageSize={ pageSize }
                        onEdit={ handleOnEdit }
                        onConfirmDelete={ handleConfirmDelete }
                        onChangePage={ (page) => setPage(page) }
                        onPageSizeChange={ (pageSize) => {
                          setPage(1)
                          setPageSize(pageSize)
                        } }
                    />
                ) }
                { item && (
                    <ModalForm
                        title={ "Edit Transfer Location" }
                        item={ item }
                        isOpen={ modalEditIsOpen }
                        toggle={ () => setModalEditIsOpen(!modalEditIsOpen) }
                        onSubmit={ handleUpdate }
                    />
                ) }
                <ModalForm
                    title={ "Add Transfer Location" }
                    isOpen={ modalAddIsOpen }
                    toggle={ () => setModalAddIsOpen(!modalAddIsOpen) }
                    onSubmit={ handleSubmit }
                />
                <ConfirmDeleteModal
                    title="Confirm Delete"
                    isOpen={ modalConfirmDeleteIsOpen }
                    toggle={ () => setModalConfirmDeleteIsOpen(!modalConfirmDeleteIsOpen) }
                    onSubmit={ handleDelete }
                />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
  )
}

TransferLocationList.propTypes = {
  transferLocation: PropTypes.object,

  getPagingTransferLocation: PropTypes.func,
  addNewTransferLocation: PropTypes.func,
  updateTransferLocation: PropTypes.func,
  getTransferLocationById: PropTypes.func,
  deleteTransferLocation: PropTypes.func,
  clearTransferLocationError: PropTypes.func,
}

const mapStateToProps = ({ transferLocation }) => {
  return {
    transferLocation
  }
}

export default withRouter(
    connect(mapStateToProps, {
      getPagingTransferLocation,
      addNewTransferLocation,
      updateTransferLocation,
      getTransferLocationById,
      deleteTransferLocation,
      clearTransferLocationError,
    })(TransferLocationList)
)
